import {useRef} from 'react';
import useToggle from "../../shared/functions/useToggle";

import {isFunction} from 'lodash';
import PropTypes from 'prop-types';

import {Stack, Alert, Button, CircularProgress} from '@mui/material';
import MenuPopover from './MenuPopover';


MessagePrompt.propTypes = {
    text: PropTypes.string.isRequired,
    element: PropTypes.element.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default function MessagePrompt({onConfirm, text, pending = false, element, color = 'error'}) {
    const anchor = useRef();

    const {open, handleClose, handleOpen} = useToggle();

    const handleConfirm = () => {
        isFunction(onConfirm) && onConfirm();
        handleClose();
    };

    return (
        <>

            <div ref={anchor} onClick={handleOpen}>
                {element}
            </div>

            <MenuPopover sx={{width: 500}} open={open} onClose={handleClose} anchorEl={anchor.current}>
                <Alert severity={color}>
                    {text}
                </Alert>
                <Stack direction='row' spacing={3} sx={{p: 1, float: 'right'}}>
                    <Button color='info' disabled={pending} onClick={handleClose}> Non, annuler</Button>
                    <Button color='error' disabled={pending} onClick={handleConfirm}>
                        {pending ? <CircularProgress color='primary' size={20}/> : ' Oui'}
                    </Button>
                </Stack>
            </MenuPopover>
        </>
    );
}
